import React from 'react';

const Footer = () => (
  <footer className="mdl-mini-footer">
    <div className="mdl-mini-footer__left-section">
      <div className="mdl-logo">Palveluehtogeneraattori</div>
      <ul className="mdl-mini-footer__link-list">
        <li><a>Help</a></li>
        <li><a>Privacy & Terms</a></li>
      </ul>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js